import { IrisPaginatedResponse } from '@services/iris-api.types'
import irisApi from 'src/services/iris-api'

import { Dashboard, DashboardType, Sitemap } from './dashboard.types'

type GetDashboardByIdArgs = {
  dashboardId: string
}
export const getDashboardById = async ({ dashboardId }: GetDashboardByIdArgs) => {
  const url = `v1/dashboards/${dashboardId}`

  const { data } = await irisApi.get<Dashboard>(url)
  return data
}

type GetDashboardByTypeArgs = {
  type: DashboardType
  name?: string
}
export const getDashboardByType = async ({ name, type }: GetDashboardByTypeArgs) => {
  const url = `v1/dashboards?type=${type}${name ? `&${name}` : ''}`

  const { data } = await irisApi.get<IrisPaginatedResponse<Dashboard>>(url)
  return data
}

export const getSitemap = async () => {
  const url = 'v1/compass-sitemap'

  const { data } = await irisApi.get<IrisPaginatedResponse<Sitemap>>(url)
  return data
}
